module.exports = __webpack_public_path__ + "static/HazelSitemap.bb2eb475.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/HazelSitemap.gif
// module id = 394
// module chunks = 246227742792961